import { supabase } from '../supabaseClient'

export const invokeEdgeFunction = async (functionName: string, body: any) => {
  const { data, error } = await supabase.functions.invoke(functionName, {
    body: typeof body === 'string' ? body : JSON.stringify(body),
  })

  if (error) throw error
  return data
}